import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twofiveseaterbusforganpatipule() {



const cardData =
{
  keyword: '25 Seater Bus for Ganpatipule',
  heading: 'Sanavi Travels: 25 Seater Bus for Ganpatipule',
  headingDescription: 'Sanavi Travels offers reliable and comfortable 25 Seater Bus for Ganpatipule services, ideal for families, friends, corporate teams, pilgrims, and tour groups planning a peaceful and scenic Konkan journey. Our well-maintained buses and experienced drivers ensure a smooth, safe, and enjoyable outstation travel experience from Pune and surrounding areas to Ganpatipule.',

  top: 'Top Travel Experiences & Attractions While Visiting Ganpatipule',

  "topPlaces": [
    {
      "title": "Ganpatipule Temple Darshan",
      "description": "Ganpatipule Temple is one of the most revered pilgrimage destinations in Maharashtra, drawing devotees from across the state and beyond. Traveling in a 25 seater bus allows families and pilgrim groups to stay together throughout the journey, creating a calm and spiritual atmosphere from departure to arrival. The bus journey offers ample seating, stable rides, and organized group movement, making it easier for elders and children to travel comfortably. Professional drivers ensure timely arrival for darshan schedules, while the group travel format reduces stress, confusion, and travel fatigue. This makes temple visits more meaningful and well-coordinated."
    },
    {
      "title": "Ganpatipule Beach Experience",
      "description": "Ganpatipule Beach is famous for its clean shoreline, serene ambiance, and scenic beauty. A 25 seater bus is ideal for group beach visits, allowing everyone to travel together with picnic items, food supplies, and personal belongings. Passengers can relax and enjoy the Konkan scenery en route, while avoiding parking hassles and route confusion. Group travel enhances safety, coordination, and enjoyment, especially for families, corporate picnics, and friend groups."
    },
    {
      "title": "Konkan Scenic Coastal Drive",
      "description": "The journey to Ganpatipule is as beautiful as the destination itself, featuring lush greenery, winding ghats, rivers, and coastal landscapes. Traveling by bus allows passengers to enjoy the scenery without the stress of driving. Large windows, smooth suspension, and relaxed seating let travelers capture photos, enjoy conversations, and fully experience the Konkan route together. This shared travel experience strengthens group bonding and makes the journey memorable."
    },
    {
      "title": "Family Vacation & Leisure Trip",
      "description": "Ganpatipule is a preferred destination for peaceful family vacations. A 25 seater bus ensures all family members, including elders and children, travel together comfortably. Families benefit from organized travel, reduced fatigue, and a relaxed atmosphere throughout the journey. The convenience of single-vehicle travel simplifies planning and ensures everyone arrives refreshed and ready to enjoy the beach, temple, and local attractions."
    },
    {
      "title": "Corporate Retreats & Team Trips",
      "description": "Corporate teams often choose Ganpatipule for retreats, bonding programs, and relaxation trips. A 25 seater bus provides disciplined and punctual group travel, allowing employees to interact, relax, and set a positive tone before reaching the destination. Professional transportation reflects good planning and enhances employee satisfaction during corporate outings."
    },
    {
      "title": "Friends Group Picnic & Tour",
      "description": "Friends planning leisure trips or weekend getaways to Ganpatipule prefer 25 seater buses for convenience and affordability. Traveling together eliminates coordination issues and allows shared enjoyment throughout the journey. Music, conversations, and scenic views make the road trip an enjoyable part of the overall travel experience."
    },
    {
      "title": "Wedding & Family Function Travel",
      "description": "Ganpatipule is sometimes chosen for destination weddings or post-wedding leisure trips. A 25 seater bus helps manage guest transportation efficiently, ensuring timely arrivals and comfortable group travel during important family occasions."
    },
    {
      "title": "Student & Educational Tours",
      "description": "Educational institutions and student groups visiting coastal and cultural destinations benefit from organized bus travel. A 25 seater bus allows teachers to supervise students easily, maintain discipline, and ensure safety throughout the journey."
    },
    {
      "title": "Overnight & Outstation Tours",
      "description": "Ganpatipule trips often involve overnight stays. Outstation-ready 25 seater buses offer sufficient luggage space, reliable performance, and comfort for long journeys, ensuring travelers remain relaxed and safe."
    },
    {
      "title": "Customized Group Itineraries",
      "description": "Every group has unique travel needs. 25 seater bus rentals allow customized routes, flexible pickup points, and adjustable schedules, ensuring the trip aligns perfectly with spiritual, leisure, or corporate travel plans."
    }
  ],

  "services": [
    {
      "name": "25 Seater Bus for Ganpatipule",
      "description": "Sanavi Travels provides dedicated 25 seater bus rental services for Ganpatipule, ensuring safe, comfortable, and well-coordinated group travel. These buses are ideal for medium-sized groups seeking a balance of comfort and affordability. Spacious seating, smooth rides, and experienced drivers familiar with Konkan routes ensure stress-free travel. Families, pilgrims, corporate teams, and tourists benefit from organized scheduling, transparent pricing, and dependable service throughout the journey."
    },
    {
      "name": "AC 25 Seater Bus Ganpatipule",
      "description": "AC 25 seater buses offer enhanced comfort for long coastal journeys. Air-conditioned interiors reduce fatigue, keep passengers relaxed, and make travel pleasant even during warm weather."
    },
    {
      "name": "Non AC 25 Seater Bus Hire Ganpatipule",
      "description": "Non-AC 25 seater buses provide a budget-friendly option for groups planning economical travel without compromising on safety or seating comfort."
    },
    {
      "name": "Luxury 25 Seater Bus Ganpatipule",
      "description": "Luxury buses feature upgraded interiors and superior seating, making them suitable for premium group travel, VIP guests, and special occasions."
    },
    {
      "name": "25 Seater Bus for Family Ganpatipule",
      "description": "Family-focused bus services prioritize comfort, safety, and convenience for travelers of all ages, ensuring relaxed group journeys."
    },
    {
      "name": "25 Seater Bus for Corporate Ganpatipule",
      "description": "Corporate bus services ensure punctual, professional, and organized travel for team outings and retreats."
    },
    {
      "name": "25 Seater Bus for Group Ganpatipule",
      "description": "Group travel buses help keep everyone together, simplifying coordination and enhancing the overall travel experience."
    },
    {
      "name": "Affordable 25 Seater Bus Rental Ganpatipule",
      "description": "Affordable rental plans allow groups to manage travel budgets efficiently while enjoying reliable transportation."
    },
    {
      "name": "Best 25 Seater Bus Service Ganpatipule",
      "description": "Sanavi Travels is trusted for consistent service quality, punctuality, and customer satisfaction on Ganpatipule routes."
    },
    {
      "name": "25 Seater Bus with Driver Ganpatipule",
      "description": "All buses include experienced drivers familiar with Konkan highways and ghats, ensuring safe and smooth travel."
    },
    {
      "name": "Bus for Wedding 25 Seater Ganpatipule",
      "description": "Wedding-related group travel is managed efficiently with organized bus services that reduce logistical stress."
    },
    {
      "name": "Bus for Picnic 25 Seater Ganpatipule",
      "description": "Picnic bus services support relaxed group outings with coordinated travel and comfortable seating."
    },
    {
      "name": "Outstation 25 Seater Bus Ganpatipule",
      "description": "Outstation buses are designed for long-distance journeys, offering reliability, comfort, and adequate luggage space."
    },
    {
      "name": "25 Seater Bus for Tour Ganpatipule",
      "description": "Tour buses provide flexible travel options for sightseeing, temple visits, and leisure exploration in Ganpatipule."
    }
  ],

  "tableData": [
    ["25 Seater Bus", "Ganpatipule Trip"],
    ["AC Bus", "Non AC Bus"],
    ["Family Travel", "Corporate Travel"],
    ["Outstation Tour", "Group Picnic"],
    ["Affordable", "Luxury Options"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Experienced Konkan Route Drivers",
      "WhyChoosedescription": "Our drivers have extensive experience navigating Konkan coastal roads, ghats, and highways. Their route knowledge ensures smooth driving, safe handling of curves, and timely arrivals, giving passengers complete peace of mind throughout the journey."
    },
    {
      "WhyChooseheading": "Comfort-Focused Group Travel",
      "WhyChoosedescription": "The 25 seater buses are maintained for long-distance comfort with spacious seating, proper legroom, and smooth suspension, ensuring travelers remain relaxed and refreshed."
    },
    {
      "WhyChooseheading": "Perfect Capacity for Medium Groups",
      "WhyChoosedescription": "A 25 seater bus offers the ideal balance between capacity and comfort, making it suitable for families, corporate teams, and pilgrim groups traveling together."
    },
    {
      "WhyChooseheading": "Transparent & Budget-Friendly Pricing",
      "WhyChoosedescription": "Clear pricing policies with no hidden charges help groups plan their Ganpatipule trip confidently and stay within budget."
    },
    {
      "WhyChooseheading": "Clean & Well-Maintained Fleet",
      "WhyChoosedescription": "All buses are regularly cleaned, sanitized, and serviced to ensure hygiene, safety, and reliable performance on long routes."
    },
    {
      "WhyChooseheading": "Flexible Pickup & Scheduling",
      "WhyChoosedescription": "Custom pickup points, departure times, and route adjustments allow the trip to be tailored to group preferences."
    },
    {
      "WhyChooseheading": "Trusted Travel Partner",
      "WhyChoosedescription": "Sanavi Travels is known for dependable outstation services and consistent customer satisfaction across Maharashtra."
    },
    {
      "WhyChooseheading": "End-to-End Travel Support",
      "WhyChoosedescription": "From booking to journey completion, our support team ensures smooth coordination and prompt assistance whenever required."
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide 25 seater buses for Ganpatipule from Pune?',
    answer: 'Yes, Sanavi Travels offers 25 seater bus rental services from Pune and nearby areas to Ganpatipule. We provide AC, Non-AC, and luxury options suitable for families, pilgrims, corporate teams, and tourist groups, ensuring safe and comfortable outstation travel.'
  },
  {
    question: 'Is the service suitable for family trips and senior citizens?',
    answer: 'Absolutely. Our 25 seater buses offer comfortable seating, smooth rides, and experienced drivers, making them ideal for families and senior citizens traveling to Ganpatipule.'
  },
  {
    question: 'Are AC buses available for Ganpatipule travel?',
    answer: 'Yes, AC 25 seater buses are available and recommended for long journeys, especially during warm weather, to enhance passenger comfort.'
  },
  {
    question: 'Can corporate groups book this service?',
    answer: 'Yes, corporate groups frequently book 25 seater buses for team outings, retreats, and leisure trips to Ganpatipule with professional coordination.'
  },
  {
    question: 'Are drivers familiar with Konkan routes?',
    answer: 'Yes, all drivers are well-experienced with Konkan coastal roads and ghats, ensuring safe navigation and timely arrivals.'
  },
  {
    question: 'Is this suitable for overnight trips?',
    answer: 'Yes, our buses are suitable for overnight and multi-day trips, offering comfort and sufficient luggage space.'
  },
  {
    question: 'Can pickup points be customized?',
    answer: 'Yes, pickup locations and departure timings can be customized based on group requirements.'
  },
  {
    question: 'Is pricing transparent?',
    answer: 'Yes, all pricing is transparent with no hidden charges, allowing easy budgeting and planning.'
  },
  {
    question: 'Is the service suitable for weddings or picnics?',
    answer: 'Yes, 25 seater buses are commonly used for wedding-related travel, picnics, and group leisure trips to Ganpatipule.'
  },
  {
    question: 'How early should we book?',
    answer: 'Advance booking is recommended, especially during weekends, holidays, and peak travel seasons, to ensure availability.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshpande',
    feedback: 'We hired a 25 seater bus from Sanavi Travels for our family and relatives trip to Ganpatipule, and the entire experience was excellent. The bus was very clean, spacious, and comfortable for a long coastal journey. The driver was polite, experienced, and extremely familiar with Konkan routes, which made us feel safe throughout the trip. Traveling together in one bus made coordination easy and allowed everyone to enjoy the journey peacefully. It truly added to the joy of our Ganpatipule visit.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rutuja Kulkarni',
    feedback: 'Our group of friends booked a 25 seater bus to Ganpatipule with Sanavi Travels, and we were very happy with the service. The booking process was smooth, pricing was transparent, and the bus arrived exactly on time. The ride was comfortable, and the driver handled ghats and highways very safely. Traveling together made the trip fun and memorable, and we would definitely recommend this service for group tours.',
    rating: 5
  }
];





























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "25 Seater Bus for Ganpatipule - Sanavi Travels",
  "description": "Sanavi Travels offers 25 seater buses for Ganpatipule trips, including AC, Non-AC, luxury, and mini bus options. Ideal for family trips, corporate travel, weddings, picnics, outstation tours, and group travel with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | 25 Seater Bus for Ganpatipule | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 25 seater buses for Ganpatipule with Sanavi Travels. AC, Non-AC, luxury, and mini bus options for family, corporate, wedding, picnic, and outstation travel with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/297.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Twofiveseaterbusforganpatipule;